import * as React from "react";
import styled from "styled-components";
import { ExternalLink, NoEntitiesExist } from "components/common";
import { Row } from "security-app/components/common/FormBaseStyles";
import { DataWell } from "security-app/components/common";
import { randomHexString } from "security-app/components/common/helperFunctions";
import CVSSHeatBadge from "./CVSSHeatBadge";
import { NoEntitiesExistWrapper } from "../shared";
const DOCS_BY_SCANNER_TYPE = {
  nessus: "https://www.tenable.com/plugins/nessus/"
};
const ID_LABEL_BY_SCANNER_TYPE = {
  qualys: "Qualys ID "
};
const CVSSSpan = styled.span`
  min-width: 70px;
`;
function VulnerabilitiesInfo({ vulnerabilities }) {
  if (!vulnerabilities.length) {
    return /* @__PURE__ */ React.createElement(NoEntitiesExistWrapper, null, /* @__PURE__ */ React.createElement(NoEntitiesExist, null, "No Vulnerabilities reported"));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, vulnerabilities.map((vuln) => /* @__PURE__ */ React.createElement(DataWell, { key: randomHexString(12), title: vuln.scannerType }, /* @__PURE__ */ React.createElement(Row, { $justify: "space-between", $align: "center" }, /* @__PURE__ */ React.createElement(Row, { $align: "center" }, DOCS_BY_SCANNER_TYPE[vuln.scannerType] && vuln.vulnerability_id ? /* @__PURE__ */ React.createElement(ExternalLink, { href: DOCS_BY_SCANNER_TYPE[vuln.scannerType] + encodeURIComponent(vuln.vulnerability_id) }, (ID_LABEL_BY_SCANNER_TYPE[vuln.scannerType] || "") + vuln.vulnerability_id) : vuln.vulnerability_id && /* @__PURE__ */ React.createElement("span", null, (ID_LABEL_BY_SCANNER_TYPE[vuln.scannerType] || "") + vuln.vulnerability_id), /* @__PURE__ */ React.createElement(CVSSSpan, null, "CVSS: ", (vuln.cvss || 0).toFixed(1)), /* @__PURE__ */ React.createElement(CVSSHeatBadge, { cvss: vuln.cvss })), vuln.cve ? /* @__PURE__ */ React.createElement(ExternalLink, { href: `https://nvd.nist.gov/vuln/detail/${encodeURIComponent(vuln.cve)}` }, vuln.cve) : null))));
}
export default VulnerabilitiesInfo;
